export const spreadLayout = {
    pour: {name: 'Pour', gridX: 0, gridY: 1},
    contre: {name: 'Contre', gridX: 2, gridY: 1},
    vibration: {name: 'Vibration', gridX: 1, gridY: 0},
    direction: {name: 'Direction', gridX: 1, gridY: 2},
    synthese: {name: 'Synthèse', gridX: 1, gridY: 1}
}

export const spreadActions = () => [
    {order: 1, setCards: (newCard, currentResult) => {
        currentResult.pour = newCard
    }, target: 'pour'},
    {order: 2, setCards: (newCard, currentResult) => {
        currentResult.contre = newCard
    }, target: 'contre'},
    {order: 3, setCards: (newCard, currentResult) => {
        currentResult.vibration = newCard
    }, target: 'vibration'},
    {order: 4, setCards: (newCard, currentResult) => {
        currentResult.direction = newCard
    }, target: 'direction'},
    {order: 5, setCards: (newCard, currentResult) => {
        currentResult.synthese = newCard
    }, target: 'synthese'},
]

export default {
    spreadLayout, spreadActions
}
